import { fmtDate, fmtPrice } from "../utils/format";
import "../styles/AdminItemList.css";

function isVideo(item) {
  return item?.mediaType === "video" || (item?.img && String(item.img).startsWith("data:video"));
}

export default function AdminItemList({ items, type, onRemove }) {
  const labels = {
    shop: { noun: "artwork", badge: "Shop", badgeClass: "badge-shop" },
    classroom: { noun: "session", badge: "Session", badgeClass: "badge-classroom" },
    gallery: { noun: "piece", badge: "Gallery", badgeClass: "badge-gallery" },
    feedback: { noun: "entry", badge: "Feedback", badgeClass: "badge-classroom" },
  };
  const meta = labels[type] || labels.gallery;

  if (items.length === 0) {
    return (
      <div className="admin-list-empty">
        No {meta.noun}s yet.
      </div>
    );
  }

  return (
    <div>
      <p className="admin-list-count">
        {items.length} {meta.noun}{items.length !== 1 ? "s" : ""}
      </p>

      <div className="admin-list">
        {items.map((item) => {
          const title = item.title || item.name || "Untitled";
          const video = isVideo(item);
          const src = item.img || item.picha || item.avatar;
          return (
            <div key={item.id} className="admin-item">
              <div className="admin-item-thumb">
                {src && video ? (
                  <video src={src} muted playsInline />
                ) : src ? (
                  <img src={src} alt={title} />
                ) : type === "shop" ? "🎨" : "📸"}
              </div>

              <div className="admin-item-info">
                <div className="admin-item-name">{title}</div>
                <div className="admin-item-meta">
                  {video ? "Video · " : "Photo · "}
                  {type === "shop"
                    ? `${item.category} · ${fmtPrice(item.price)}`
                    : type === "classroom"
                    ? fmtDate(item.date)
                    : type === "feedback"
                    ? (item.role || "Feedback")
                    : "Gallery"}
                </div>
                {type !== "gallery" && (
                  <div className="admin-item-meta admin-item-desc">
                    {(type === "shop" ? item.details : item.desc)?.substring(0, 80)}
                    {(type === "shop" ? item.details : item.desc)?.length > 80 ? "…" : ""}
                  </div>
                )}
              </div>

              <span className={`badge ${meta.badgeClass}`}>
                {meta.badge}
              </span>

              <div className="admin-item-actions">
                <button
                  className="btn btn-sienna btn-xs"
                  onClick={() => onRemove(item.id)}
                >
                  Remove
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
